import React from 'react';
import { XCircleIcon, DollarSignIcon, ArrowRightIcon } from 'lucide-react';
export function ProblemSection() {
  const problems = ["You're paying Yelp, Meta, and Google every month, but half your online leads go cold before you can reply.", "You're juggling too many tools: Calendly, Mailchimp, random CRMs, spreadsheets, and DMs across three apps.", 'You have no clean way to see which leads actually booked and what your real ROI is from ads.', 'Follow-up is manual and inconsistent, so hot leads go to whoever answers them first.', "You're overpaying for a stack of third-party tools that still don't talk to each other."];
  const moneyPoints = ['Every cold lead is a job your competitor gets.', 'Saving just 3–5 jobs per month can mean thousands in extra revenue.', 'Most clients cut hundreds per month by canceling overlapping tools.'];
  return <section className="w-full bg-white-smoke py-16 md:py-24 px-4 relative" data-id="element-151">
      {/* Angled top divider */}
      <div className="absolute top-0 left-0 right-0 h-16 bg-jet-black" style={{
      clipPath: 'polygon(0 0, 100% 0, 100% 0%, 0 100%)'
    }} data-id="element-152" />

      <div className="max-w-6xl mx-auto pt-8" data-id="element-153">
        <div className="text-center mb-12" data-id="element-154">
          <h2 className="text-3xl md:text-5xl font-extrabold text-jet-black mb-6" data-id="element-155">
            Your Ads Are Working.{' '}
            <span className="text-red-600" data-id="element-156">Your Follow-Up Isn't.</span>
          </h2>
          <p className="text-lg md:text-xl text-graphite-gray max-w-3xl mx-auto leading-relaxed" data-id="element-157">
            You're spending real money on Yelp, Meta, and Google to generate
            leads. But when a quote request comes in and sits for hours, that
            homeowner has already booked with someone else.
          </p>
        </div>

        {/* Pain points */}
        <div className="bg-white rounded-xl shadow-lg p-8 md:p-10 max-w-4xl mx-auto mb-12" data-id="element-158">
          <ul className="space-y-5" data-id="element-159">
            {problems.map((problem, index) => <li key={index} className="flex items-start gap-4" data-id="element-160">
                <XCircleIcon className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" strokeWidth={2.5} data-id="element-161" />
                <span className="text-lg text-graphite-gray font-medium leading-relaxed" data-id="element-162">
                  {problem}
                </span>
              </li>)}
          </ul>
        </div>

        {/* Money tie-in */}
        <div className="bg-jet-black rounded-xl p-8 md:p-10 max-w-4xl mx-auto" data-id="element-163">
          <div className="flex items-center gap-3 mb-6" data-id="element-164">
            <DollarSignIcon className="w-8 h-8 text-viridia-green" strokeWidth={2.5} data-id="element-165" />
            <h3 className="text-2xl font-bold text-white" data-id="element-166">
              This Is Costing You Real Money
            </h3>
          </div>
          <ul className="space-y-4" data-id="element-167">
            {moneyPoints.map((point, index) => <li key={index} className="flex items-start gap-3" data-id="element-168">
                <ArrowRightIcon className="w-5 h-5 text-viridia-green flex-shrink-0 mt-1" strokeWidth={2.5} data-id="element-169" />
                <span className="text-lg text-gray-300 font-medium" data-id="element-170">
                  {point}
                </span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}